// extracted by mini-css-extract-plugin
module.exports = {"banner":"_c63c484"};